/* eslint-disable max-len */
import { SvgProps } from './types'

export const BullseyeIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M23.9872 21.7876C24.4383 23.5328 23.9793 25.4679 22.614 26.8371C20.5562 28.8948 17.2202 28.8948 15.1625 26.8371C13.1047 24.7793 13.1047 21.4433 15.1625 19.3855C16.5356 18.0124 18.4787 17.5573 20.2278 18.0163"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5468 17.2169C31.21 21.5738 30.656 27.3435 26.8887 31.1148C22.4684 35.535 15.3058 35.535 10.8855 31.1148C6.46525 26.6945 6.46525 19.5319 10.8855 15.1116C14.6568 11.3403 20.4265 10.7863 24.7834 13.4535"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.0518 1.52637V6.94782H40.4732L34.6402 12.7769H29.2188V7.35541L35.0518 1.52637Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2191 12.7769L18.8867 23.1132"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.56 7.53349C20.0741 4.33602 12.0052 5.43614 6.60753 10.8338C-0.171259 17.6126 -0.171259 28.6059 6.60753 35.3887C13.3863 42.1674 24.3796 42.1674 31.1623 35.3887C36.56 29.9909 37.6602 21.9181 34.4627 15.4322"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
